import styled from 'styled-components';
import IsolatedScroll from 'react-isolated-scroll';
import { pxToRem, vars } from '$util/theme';

export const Styled = styled(IsolatedScroll)`
  margin-top: 5px;
  border: 1px solid ${vars.quantumverse.reskinColors.neutral200};
  border-radius: ${vars.defaultBorderRadius};
  overflow-x: hidden;
  background-color: #fff;
  text-align: left;

  display: none;
  &.-loading,
  &.-empty,
  &.react-autosuggest__suggestions-container--open {
    display: block;
  }

  &.-loading > .fixter-preloader {
    margin: 60px auto;
  }
  > ul {
    padding: 0;
    margin: 0;
    list-style: none;
    > li {
      padding: 15px 20px;
      cursor: pointer;
      background-color: #fff;
      &.react-autosuggest__suggestion--highlighted {
        background-color: ${vars.quantumverse.reskinColors.neutral100};
      }
    }
  }
  .no-results {
    margin: 60px auto;
    text-align: center;
    font-size: ${pxToRem(16)};
    h3 {
      font-size: ${pxToRem(18)};
      font-weight: 600;
    }
    .Image {
      margin-bottom: 20px;
    }
  }
`;
